module.exports = __webpack_public_path__ + "static/media/prev.853dc411.png";